/* global WMP */

import {WixSdk} from 'js-sdk-wrapper';
import {logToActivities} from './activities';
import {logToBi} from './bi';
import {logToCounters} from './counters';

interface WixParams {
  compId?: string;
  userId?: string;
  visitorId?: string;
  instanceId?: string;
  biToken?: string;
  siteOwnerId?: string;
  isOwner?: boolean;
}
export function getWixParams(): WixParams {
  const getters = {
    compId: () => WixSdk.Utils.getCompId(),
    userId: () => WixSdk.Utils.getUid(),
    visitorId: () => WMP.wixUtils.getVisitorId(),
    instanceId: () => WMP.wixUtils.getInstanceId(),
    biToken: () => WMP.wixUtils.getBiToken(),
    siteOwnerId: () => WixSdk.Utils.getSiteOwnerId(),
    isOwner: () => WixSdk.Utils.getUid() === WixSdk.Utils.getSiteOwnerId()
  };

  return Object.keys(getters).reduce((_options, key) => {
    try {
      _options[key] = getters[key]();
    } catch (ex) {
      console.warn(`Cannot get param ${key}`, ex); // eslint-disable-line no-console
    }
    return _options;
  }, {});
}

export function logPlayerEvents(eventEmitter, options) {
  options = {...options, ...getWixParams()};
  const loggers = [
    logToActivities,
    logToBi,
    logToCounters,
  ];
  loggers.forEach((logger: any) => {
    try {
      logger(eventEmitter, options);
    } catch (ex) {
      console.error('Cannot initialize logger', ex); // eslint-disable-line no-console
    }
  });
}



// WEBPACK FOOTER //
// ./statistics/send-event.ts